import { Overview } from '../Overview';
import { Result } from './Result';
import { styled } from 'styled-components';
import { LoadingSpinner, tk } from '@sunwebgroup/ui-components';
import { useUserReviews, useUserReviewsInitialData } from '@/scopes/products/user-reviews/hooks';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${tk('spacing_2xl')};
  padding-bottom: ${tk('spacing_2xl')};
  padding-left: ${tk('spacing_lg')};
  padding-right: ${tk('spacing_lg')};

  ${Overview.Wrapper} {
    width: 100%;

    @media ${tk('mq_desktop_md')} {
      width: 30%;
    }
  }

  ${Result.Wrapper} {
    width: 100%;

    @media ${tk('mq_desktop_md')} {
      width: 70%;
    }
  }

  @media ${tk('mq_desktop_sm')} {
    padding: ${tk('spacing_2xl')};
  }

  @media ${tk('mq_desktop_md')} {
    flex-direction: row;
  }
`;

const WrapperLoading = styled.div`
  display: flex;
  justify-content: center;
  padding: ${tk('spacing_2xl')};
`;

const WrapperOnlyResult = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${tk('spacing_2xl')};
  padding-bottom: ${tk('spacing_2xl')};
  padding-left: ${tk('spacing_lg')};
  padding-right: ${tk('spacing_lg')};

  ${Result.Wrapper} {
    width: 100%;
  }

  @media ${tk('mq_desktop_sm')} {
    padding: ${tk('spacing_2xl')};
  }
`;

export function ExtendedContent() {
  const { isLoading } = useUserReviews();
  const { reviewsAmount, isFetched } = useUserReviewsInitialData();

  if (isLoading) {
    return (
      <WrapperLoading>
        <LoadingSpinner />
      </WrapperLoading>
    );
  }

  if (isFetched && reviewsAmount < 3)
    return (
      <WrapperOnlyResult>
        <Result />
      </WrapperOnlyResult>
    );

  return (
    <Wrapper>
      <Overview />
      <Result />
    </Wrapper>
  );
}
